/**
 * withStockCounters
 * HOC for wrapping the provided component with StockCountersProvider
 */

import React from 'react'

import StockCountersProvider from './stock-counters-provider'

export default function withStockCounters(WrappedComponent) {
  return function StockCountersProviderHOC(props) {
    return (
      <StockCountersProvider>
        <WrappedComponent {...props} />
      </StockCountersProvider>
    )
  }
}
